module.exports = __webpack_public_path__ + "static/media/icon_whats_black.08608b55.svg";